<template>
    <!--    <div class="bot-file-message">-->
    <!--        <div class="media-content-wrapper">-->
    <!--            <a :href="fileSrc()" download target="_blank">-->
    <!--                <div-->
    <!--                    v-if="getFile(fileSrc())"-->
    <!--                    :class="`fi-${getFile(fileSrc())}`"-->
    <!--                    class="fi"-->
    <!--                >-->
    <!--                    <div class="fi-content">{{ getFile(fileSrc()) }}</div>-->
    <!--                </div>-->
    <!--                <p class="media-content-text">-->
    <!--                    {{ $t("message.download") }}-->
    <!--                </p>-->
    <!--            </a>-->
    <!--        </div>-->

    <!--        <span v-if="data.data.meta" class="message">{{ data.data.meta }}</span>-->
    <!--    </div>-->
    <div
        class="bot-file-message assetMessage sc-message--text"
        :style="{ ...(messageColors || {}), ...(extendedStyle || {}) }"
        @click="openGallery"
    >
        <div class="media-content-wrapper">
            <a :href="fileSrc()" download target="_blank" @click.stop>
                <div v-if="getFile(fileSrc())" :class="`fi-${getFile(fileSrc())}`" class="fi">
                    <div class="fi-content">{{ getFile(fileSrc()) }}</div>
                </div>
                <p :class="data.author === 'me' ? 'received' : 'sent'" class="media-content-text">
                    {{ $t("message.download") }}
                </p>
            </a>
        </div>
        <span v-if="data.data.meta" :class="data.author === 'me' ? 'received' : 'sent'" class="sc-message--meta">{{
            data.data.meta
        }}</span>
    </div>
</template>

<script>
import { getExtensionFromFileName } from "../../../../utils/utils";
import _ from "lodash";

export default {
    name: "BotFileMessage",
    props: ["data", "messageColors", "extendedStyle"],
    data() {
        return {
            previewImg: false,
        };
    },
    methods: {
        openGallery() {
            this.$emit("open-gallery", this.data);
        },
        fileSrc() {
            const fileUrl =
                _.get(this.data, "raw.payload.fileUrl", _.get(this.data, "raw.payload")) ||
                _.get(this.data, "raw.payload");
            return fileUrl;
        },
        getFile(fileSrc) {
            return getExtensionFromFileName(fileSrc);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

.bot-file-message {
    position: relative;
    border: 1px solid #66666626;
    padding: 10px;

    .cb-img-preview:hover {
        cursor: pointer;
        filter: grayscale(100%);
    }

    .message {
        margin: 18px 6px;
        border-radius: 6px;
    }

    .media-content-wrapper {
        margin: 4px;

        .media-content-text {
            margin-bottom: 0;
            font-family: Poppins, monospace;
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
        }
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }
}
</style>
